import { combineReducers } from 'redux'

import { TOP_CONSIGNEE_LOADING, TOP_CONSIGNEE_SUCCESS, TOP_CONSIGNEE_ERROR } from '../actions/dashboardActionTopConsignee';

let initialState = {
    loading: false,
    success: false,
    error: false,
    data: {}
}

const topConsignee = (state = initialState, action) => {
    switch (action.type) {
        case TOP_CONSIGNEE_LOADING:
            return {
                ...state,
                loading: action.loading
            }
        case TOP_CONSIGNEE_SUCCESS:
            return {
                ...state,
                success: action.success,
                data: action.data
            }
        case TOP_CONSIGNEE_ERROR:
            return {
                ...state,
                success: action.error,
            }
        default:
            return state
    }
}

export default combineReducers({
    topConsignee
})